import { cn } from '../../lib'
import type { SelectableCardProps } from './selectable-card.types'

import { selectableCardStyle } from './selectable-card.css'

const SelectableCard = ({ className, children, selected, badge, size, ...props }: SelectableCardProps) => {
  return (
    <button
      {...props}
      className={cn(selectableCardStyle({ size }), className)}
      data-selected={selected ? 'selected' : 'un-selected'}
      aria-selected={selected}
    >
      {children}
      {badge && (
        <div className="absolute top-[-1px] right-[-0.1em] rounded-bl rounded-tl rounded-tr-xl overflow-hidden">
          {badge}
        </div>
      )}
    </button>
  )
}

SelectableCard.displayName = 'SelectableCard'

export default SelectableCard
export { SelectableCard, type SelectableCardProps }
